// Brand logo mark — replaces the "Tarush" wordmark everywhere.
// variant="dark"  => original colored logo (for light backgrounds)
// variant="light" => inverted-to-white (for navy/black backgrounds)
// className controls sizing via height utilities.

export const Logo = ({ variant = "dark", className = "h-6 md:h-7", ...rest }) => {
  const isLight = variant === "light";
  return (
    <img
      src="/tarush-logo.webp"
      alt="Tarush"
      className={`${className} w-auto object-contain select-none ${isLight ? "brand-logo-light" : ""}`}
      draggable={false}
      {...rest}
    />
  );
};

export default Logo;
